import React from 'react';
import { Link as SitecoreLink } from '@sitecore-jss/sitecore-jss-react';
import { Link as RouterLink } from 'react-router-dom';
import {isInternalUrl} from "../../utils";

/** React component that turns Sitecore link values that start are internal into react-router route links */
const RoutableSitecoreLink = (props: {field: any | undefined, editable?: boolean, [key: string]: any}) => {
    const {field, editable, children} = props;
    const hasValidHref = field && field.value && field.value.href;
    const isEditing = editable && field.editable;

    // only want to apply the routing link if not editing (if editing, need to render editable link value)
    if(hasValidHref && !isEditing) {
        const value = field.value;

        // determine if a link is a route or not. This logic may not be appropriate for all usages.
        if(isInternalUrl(value.href)) {
            return (
                <RouterLink to={value.href} title={value.title} target={value.target} className={props.className ?? value.class} onClick={props.onClick}>
                    {children || value.text || value.href}
                </RouterLink>
            );
        }
    }

    return <SitecoreLink {...props} />;
};

export default RoutableSitecoreLink;
